import React, { useEffect, useState } from "react";
import axios from "axios";

const Datadeletion = () => {
  const [dataDeletionContent, setDataDeletionContent] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchDataDeletionInstructions = async () => {
      try {
        const token = localStorage.getItem("token"); // Fetch the token from local storage
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/documents/data-deletion-instructions`,
          {
            headers: {
              Authorization: token, // Include the token in the request headers
            },
          }
        );
        setDataDeletionContent(response.data.content);
        setLoading(false);
      } catch (err) {
        setError("Failed to load data deletion instructions");
        setLoading(false);
      }
    };

    fetchDataDeletionInstructions();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  return (
    <div className="box-container">
      <div className="col-sm-12 text-center">
        <h1>Data Deletion Instructions</h1>
        <div
          className="data-deletion-content"
          dangerouslySetInnerHTML={{ __html: dataDeletionContent }}
        />
      </div>
    </div>
  );
};

export default Datadeletion;
